import { Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import moment from 'moment'
import React from 'react'
import { CommentType } from '../../views/SingleRequestPage/types/store.types'

type CommentItemProps = {
  comment: CommentType
}

export const CommentItem: React.FC<CommentItemProps> = ({ comment }) => {
  return (
    <Stack key={comment.id} sx={commentWrapperSx} spacing={'5px'}>
      <Typography sx={{ fontWeight: '700', fontSize: '14px' }}>
        {comment.author}
      </Typography>
      <Typography
        variant='body2'
        sx={{ wordWrap: 'break-word', width: '100%' }}
      >
        {comment.text}
      </Typography>
      <Typography sx={{ textAlign: 'right', fontSize: '10px' }}>
        {moment(comment.date).format('DD.MM.YYYY, HH:mm')}
      </Typography>
    </Stack>
  )
}

const commentWrapperSx = {
  backgroundColor: '#ffffffdc',
  color: '#000',
  borderRadius: '4px',
  padding: '8px 16px',
  opacity: '0.9',
  boxShadow: '0px 1px 2px 0px #00000040',
}

export default observer(CommentItem)
